import { Box, styled } from "@mui/material";

export const CheckboxContainer = styled(Box)`
  position: relative;
  border: 1px solid #ffdca8;
  border-radius: 0.25rem;
  overflow: hidden;
`;

export const Input = styled("input")`
  cursor: pointer;
  position: absolute;
  margin: 0;
  opacity: 0;
  inset: 0;
`;

export const Checkmark = styled(Box)`
  display: inline-block;
  transform: rotate(40deg) translate(-15%, -10%);
  height: 75%;
  width: 40%;
  border-bottom: 3px solid #3d2e24;
  border-right: 3px solid #3d2e24;
`;
